import axios from "axios";
import { Moment } from "moment";

// import { isAsExpression } from "typescript";

class Doc7Service1 {
  async sendDoc7(body: {
    curriCode: number;
    fileDoc7: string;
    fileDoc7Send: string;
    report: Moment | string;
    year: number;
  }) {
    return await axios.post("doc7", body);
  }

  async getAll() {
    return await axios.get("doc7");
  }

  async findDoc7(body: {
    year: string;
    level: string;
    curriCode: string;
    selectCurriCode: string;
  }) {
    return await axios.post(`doc7/findDoc7`, { ...body });
  }

  async deleteDoc7(id: number) {
    return await axios.delete(`doc7/${id}`);
  }
}

const Doc7Service = new Doc7Service1();
export default Doc7Service;
